(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(92911);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 22 22"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.0253 15.6833C11.8669 15.6833 11.7086 15.625 11.5836 15.5C11.3419 15.2583 11.3419 14.8583 11.5836 14.6167L16.2003 9.99999L11.5836 5.38333C11.3419 5.14166 11.3419 4.74166 11.5836 4.49999C11.8253 4.25833 12.2253 4.25833 12.4669 4.49999L17.5253 9.55833C17.7669 9.79999 17.7669 10.2 17.5253 10.4417L12.4669 15.5C12.3419 15.625 12.1836 15.6833 12.0253 15.6833Z",
                fill: "#292D32"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.942 10.625H2.91699C2.57533 10.625 2.29199 10.3417 2.29199 10C2.29199 9.65833 2.57533 9.375 2.91699 9.375H16.942C17.2837 9.375 17.567 9.65833 17.567 10C17.567 10.3417 17.2837 10.625 16.942 10.625Z",
                fill: "#292D32"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 83024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 6V7.79C12 8.24 12.54 8.46 12.85 8.14L15.64 5.35C15.84 5.15 15.84 4.84 15.64 4.64L12.85 1.85C12.54 1.54 12 1.76 12 2.21V4C7.58 4 4 7.58 4 12C4 13.04 4.2 14.04 4.57 14.95C4.84 15.62 5.7 15.8 6.21 15.29C6.48 15.02 6.59 14.61 6.44 14.25C6.15 13.56 6 12.79 6 12C6 8.69 8.69 6 12 6ZM17.79 8.71C17.52 8.98 17.41 9.4 17.56 9.75C17.84 10.45 18 11.21 18 12C18 15.31 15.31 18 12 18V16.21C12 15.76 11.46 15.54 11.15 15.86L8.36 18.65C8.16 18.85 8.16 19.16 8.36 19.36L11.15 22.15C11.46 22.46 12 22.24 12 21.8V20C16.42 20 20 16.42 20 12C20 10.96 19.8 9.96 19.43 9.05C19.16 8.38 18.3 8.2 17.79 8.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 38047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13193);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_meta_tags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81372);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64429);
/* harmony import */ var config_constants_meta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31574);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _pancakeswap_uikit_src_widgets_Menu_config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4449);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width:100%;\n    min-height: calc(100vh - 90px);\n    height: auto;\n    display:flex;\n    justify-content:center;\n    align-items:center;\n    flex-direction: column;\n    background-color: ",
        ";\n    margin-top: -",
        "px;\n    position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: 100vh;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    z-index: 2;\n    background:url('/images/goldbridge/bg.png?version=1.1');\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: bottom;\n    @media screen and (max-width: 1024px) and (min-width: 601px){\n      height: 90vh;\n    }\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    z-index: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: auto;\n    min-height: 80vh;\n    margin-top: ",
        "px;\n    z-index: 10;\n    display: flex;\n    flex-direction:column;\n    justify-content: flex-start;\n    align-items: center;\n    @media screen and (max-width:1000px) {\n        padding-bottom: 50px;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





// import { useLocation } from 'react-router'



var PageMeta = function() {
    var ref = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var pageMeta = (0,config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .getCustomMeta */ .S)(pathname, t, locale) || {};
    var ref1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META */ .k, pageMeta), title = ref1.title, description = ref1.description, image = ref1.image;
    var pageTitle = title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_meta_tags__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:image",
                content: image
            })
        ]
    });
};
var PageFullWidth = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageMeta, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContainerChild, {
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PageFullWidth);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-56698419-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, _pancakeswap_uikit_src_widgets_Menu_config__WEBPACK_IMPORTED_MODULE_11__/* .MENU_HEIGHT */ .d0);
var ContainerBg = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-56698419-1"
})(_templateObject1());
var ContainerChild = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-56698419-2"
})(_templateObject2(), _pancakeswap_uikit_src_widgets_Menu_config__WEBPACK_IMPORTED_MODULE_11__/* .MENU_HEIGHT */ .d0);


/***/ }),

/***/ 67519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ listApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50196);



var history = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(walletAddress) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/transaction/crosschain_history?&walletAddress=".concat(walletAddress))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function history(walletAddress) {
        return _ref.apply(this, arguments);
    };
}();
var summary = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/api/transaction/crosschain_summary?")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function summary() {
        return _ref.apply(this, arguments);
    };
}();
var crossChain = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("https://dev-api.goldbridge.io/api/transaction/data_for_crosschain?")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().data
                    ];
            }
        });
    });
    return function crossChain() {
        return _ref.apply(this, arguments);
    };
}();
var listApi = {
    history: history,
    summary: summary,
    crossChain: crossChain
};


/***/ }),

/***/ 97478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N6": function() { return /* binding */ CHAIN_ID_PAGES; },
/* harmony export */   "ZM": function() { return /* binding */ BOOSTED_FARM_GAS_LIMIT; },
/* harmony export */   "hJ": function() { return /* binding */ BSC_BLOCK_TIME; },
/* harmony export */   "iU": function() { return /* binding */ PUBLIC_KEY; },
/* harmony export */   "o3": function() { return /* binding */ DEFAULT_TOKEN_DECIMAL; },
/* harmony export */   "pR": function() { return /* binding */ TEMPLATE_ID; },
/* harmony export */   "rb": function() { return /* binding */ MAX_UINT_256; },
/* harmony export */   "x0": function() { return /* binding */ PERCENT_PRICE; },
/* harmony export */   "xb": function() { return /* binding */ SERVICE_ID; }
/* harmony export */ });
/* unused harmony exports BASE_BSC_SCAN_URLS, CAKE_PER_BLOCK, BLOCKS_PER_DAY, BLOCKS_PER_YEAR, CAKE_PER_YEAR, CAKE_PER_BLOCKV2, BLOCKS_PER_YEARV2, CAKE_PER_YEARV2, BASE_URL, BASE_ADD_LIQUIDITY_URL, DEFAULT_GAS_LIMIT, AUCTION_BIDDERS_TO_FETCH, RECLAIM_AUCTIONS_TO_FETCH, AUCTION_WHITELISTED_BIDDERS_TO_FETCH, startTimeStake, LIMIT_VOTING, IPFS_GATEWAY, AMOUNT_FULL_POOL, BASE_BSC_SCAN_URL, BASE_BSC_URL, URL, TRANDING_FEE, TRANSFER_FEE, GOOGLE_MAP_API_KEY, SUPPORT_BRIDGE, CHAINS_NETWORK, NUM_TOKEN_SUPPORT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var utils_getFullDecimalMultiplier__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27750);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1505);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70794);
/* harmony import */ var _pancakeswap_wagmi_chains__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22746);





var BSC_BLOCK_TIME = 3;
var _obj;
var BASE_BSC_SCAN_URLS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC, "https://bscscan.com"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET, "https://testnet.bscscan.com"), _obj);
// CAKE_PER_BLOCK details
// 40 CAKE is minted per block
// 20 CAKE per block is sent to Burn pool (A farm just for burning cake)
// 10 CAKE per block goes to CAKE syrup pool
// 9 CAKE per block goes to Yield farms and lottery
// CAKE_PER_BLOCK in config/index.ts = 40 as we only change the amount sent to the burn pool which is effectively a farm.
// CAKE/Block in src/views/Home/components/CakeDataRow.tsx = 15 (40 - Amount sent to burn pool)
var CAKE_PER_BLOCK = 40;
var BLOCKS_PER_DAY = 60 / BSC_BLOCK_TIME * 60 * 24;
var BLOCKS_PER_YEAR = BLOCKS_PER_DAY * 365 // 10512000
;
var CAKE_PER_YEAR = CAKE_PER_BLOCK * BLOCKS_PER_YEAR;
var CAKE_PER_BLOCKV2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(0.07);
var BLOCKS_PER_YEARV2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(60 / BSC_BLOCK_TIME * 60 * 24 * 365) // 10512000
;
var CAKE_PER_YEARV2 = CAKE_PER_BLOCKV2.times(BLOCKS_PER_YEARV2);
var MAX_UINT_256 = "115792089237316195423570985008687907853269984665640564039457.584007913129639935";
var BASE_URL = "https://onbridge-dapp-git-develop-deltalabs.vercel.app/";
var BASE_ADD_LIQUIDITY_URL = "".concat(BASE_URL, "/add");
var DEFAULT_TOKEN_DECIMAL = (0,utils_getFullDecimalMultiplier__WEBPACK_IMPORTED_MODULE_0__/* .getFullDecimalMultiplier */ .t)(18);
var DEFAULT_GAS_LIMIT = 250000;
var BOOSTED_FARM_GAS_LIMIT = 500000;
var AUCTION_BIDDERS_TO_FETCH = 500;
var RECLAIM_AUCTIONS_TO_FETCH = 500;
var AUCTION_WHITELISTED_BIDDERS_TO_FETCH = 500;
var startTimeStake = 1662469200000;
var LIMIT_VOTING = 100;
var IPFS_GATEWAY = "https://ipfs.io/ipfs";
var AMOUNT_FULL_POOL = "2500000";
var BASE_BSC_SCAN_URL = BASE_BSC_SCAN_URLS[_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC];
var BASE_BSC_URL = BASE_BSC_SCAN_URLS[_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC];
var URL = (/* unused pure expression or super */ null && ("https://dev-api.goldbridge.io"));
var TRANDING_FEE = 3;
var TRANSFER_FEE = 5;
var GOOGLE_MAP_API_KEY = "AIzaSyDWTx7bREpM5B6JKdbzOvMW-RRlhkukmVE";
var SERVICE_ID = "service_r0yjimn";
var TEMPLATE_ID = "template_s0lgp2y";
var PUBLIC_KEY = "NYIsRchjQXFxKq48J";
var _obj1;
var SUPPORT_BRIDGE = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj1, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.POLYGON */ .a_.POLYGON, [
    _pancakeswap_wagmi_chains__WEBPACK_IMPORTED_MODULE_3__/* .onusMainnet */ .ik
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj1, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.ONUS */ .a_.ONUS, [
    _pancakeswap_wagmi_chains__WEBPACK_IMPORTED_MODULE_3__/* .polygon */ .yu,
    _pancakeswap_wagmi_chains__WEBPACK_IMPORTED_MODULE_3__/* .bsc */ .eG
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj1, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC, [
    _pancakeswap_wagmi_chains__WEBPACK_IMPORTED_MODULE_3__/* .onusMainnet */ .ik
]), _obj1);
var CHAINS_NETWORK = [
    _pancakeswap_wagmi_chains__WEBPACK_IMPORTED_MODULE_3__/* .onusMainnet */ .ik,
    _pancakeswap_wagmi_chains__WEBPACK_IMPORTED_MODULE_3__/* .polygon */ .yu,
    _pancakeswap_wagmi_chains__WEBPACK_IMPORTED_MODULE_3__/* .bsc */ .eG
];
var PERCENT_PRICE = [
    {
        title: "25%",
        value: 0.25
    },
    {
        title: "50%",
        value: 0.5
    },
    {
        title: "75%",
        value: 0.75
    },
    {
        title: "100%",
        value: 1
    }
];
var CHAIN_ID_PAGES = [
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.ONUS */ .a_.ONUS,
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.POLYGON */ .a_.POLYGON,
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC,
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.ETHEREUM */ .a_.ETHEREUM
];
var NUM_TOKEN_SUPPORT = 2;


/***/ }),

/***/ 63061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "listTokens": function() { return /* binding */ listTokens; },
/* harmony export */   "tokenSupport": function() { return /* binding */ tokenSupport; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1505);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18582);




var logged = false;
var tokenSupport = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(chainId) {
        var error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        __webpack_require__(1365)("./".concat(chainId, ".ts"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().default.filter(function(f) {
                            return f.toChainId !== null;
                        })
                    ];
                case 2:
                    error = _state.sent();
                    if (!logged) {
                        console.error("Cannot get token config", error, chainId);
                        logged = true;
                    }
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function tokenSupport(chainId) {
        return _ref.apply(this, arguments);
    };
}();
var listTokens = [
    {
        name: "USDT",
        symbol: "USDT",
        fromChains: [
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.POLYGON */ .a_.POLYGON,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .polygonTokens.usdt */ .UB.usdt,
                toChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens.usdt */ .Au.usdt,
                toChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.POLYGON */ .a_.POLYGON
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ETHEREUM */ .a_.ETHEREUM,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .USDT */ .AA[_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ETHEREUM */ .a_.ETHEREUM],
                toChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.usdt */ .ds.usdt,
                toChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS
                ]
            }, 
        ],
        toChains: [
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens */ .Au === null || _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens */ .Au === void 0 ? void 0 : _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens.usdt */ .Au.usdt,
                fromChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.POLYGON */ .a_.POLYGON,
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ETHEREUM */ .a_.ETHEREUM,
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.POLYGON */ .a_.POLYGON,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .polygonTokens */ .UB === null || _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .polygonTokens */ .UB === void 0 ? void 0 : _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .polygonTokens.usdt */ .UB.usdt,
                fromChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS,
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.POLYGON */ .a_.POLYGON
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ETHEREUM */ .a_.ETHEREUM,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .USDT */ .AA[_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ETHEREUM */ .a_.ETHEREUM],
                fromChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.usdt */ .ds.usdt,
                fromChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS
                ]
            }, 
        ]
    },
    // {
    //     name: "ONUS",
    //     symbol: "ONUS",
    //     fromChains: [
    //         {
    //             chainId: ChainId.BSC,
    //             token: bscTokens.onus,
    //             toChain: [ChainId.ONUS]
    //         },
    //         {
    //             chainId: ChainId.ONUS,
    //             token: Native.onChain(ChainId.ONUS),
    //             toChain: [ChainId.BSC]
    //         },
    //     ],
    //     toChains: [
    //         {
    //             chainId: ChainId.ONUS,
    //             token: Native.onChain(ChainId.ONUS),
    //             fromChain: [ChainId.BSC]
    //         },
    //         {
    //             chainId: ChainId.BSC,
    //             token: bscTokens.onus,
    //             fromChain: [ChainId.ONUS]
    //         },
    //     ],
    // },
    {
        name: "VNDC",
        symbol: "VNDC",
        fromChains: [
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.vndc2 */ .ds.vndc2,
                toChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens */ .Au === null || _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens */ .Au === void 0 ? void 0 : _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens.vndc2 */ .Au.vndc2,
                toChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC,
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.POLYGON */ .a_.POLYGON
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.POLYGON */ .a_.POLYGON,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .polygonTokens.vndc2 */ .UB.vndc2,
                toChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS
                ]
            }, 
        ],
        toChains: [
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens */ .Au === null || _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens */ .Au === void 0 ? void 0 : _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .onusMainnetTokens.vndc2 */ .Au.vndc2,
                fromChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC,
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.POLYGON */ .a_.POLYGON
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.vndc2 */ .ds.vndc2,
                fromChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS
                ]
            },
            {
                chainId: _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.POLYGON */ .a_.POLYGON,
                token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_1__/* .polygonTokens.vndc2 */ .UB.vndc2,
                fromChain: [
                    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ONUS */ .a_.ONUS
                ]
            }, 
        ]
    }
];


/***/ }),

/***/ 31063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useCallWithMarketGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92876);







function useCallWithMarketGasPrice() {
    /**
     * Perform a contract call with a gas price returned from useGasPrice
     * @param contract Used to perform the call
     * @param methodName The name of the method called
     * @param methodArgs An array of arguments to pass to the method
     * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
     * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
     */ var callWithMarketGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, tx, ref;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                            type: "Transaction",
                            message: "Call with market gas price",
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, methodName);
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(methodArgs).concat([
                                (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, overrides)
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        callWithMarketGasPrice: callWithMarketGasPrice
    };
}


/***/ }),

/***/ 92911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
// EXTERNAL MODULE: ./src/components/Layout/PageFullWidth.tsx
var PageFullWidth = __webpack_require__(38047);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(13193);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(95867);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(9919);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(64429);
;// CONCATENATED MODULE: ./src/views/HomePage/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    background: #ffff;\n    flex-direction: column;\n    width: 100%;\n    height:auto;\n    @media screen and (max-width:1000px){\n        background: linear-gradient(360deg, #FFF 0%, #FDF9ED 66.56%, #FFF 100%);\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #ffff;\n    max-width: 60px;\n    width: 100%;\n    color: #000;\n    border-right: 1px solid #E3E3E8;\n    margin-top: 8px;\n    margin-bottom:8px;\n    margin-right: 24px;\n    margin-left: 24px;\n    @media screen and (max-width:1000px) {\n        display: none;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 1120px;\n    width: 100%;\n    margin: 40px auto 0 auto;\n    @media screen and (max-width: 1000px) {\n        margin: 20px auto 0 auto;\n    }\n    .swiper-slide {\n        text-align: center;\n        font-size: 18px;\n        background: radial-gradient(103.03% 103.03% at 0% 0%, #717171 0%, #242424 100%);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 24px;\n        height: 195px;\n        @media screen and (max-width:1000px) {\n            border-radius: 0px;\n            height: 250px;\n        }\n    }\n    .swiper-pagination-bullet-active,.swiper-pagination-bullet{\n        background: #ffff;\n        width: 24px;\n        height: 2px;\n        border-radius: 1px;\n        @media screen and (max-width:1000px) {\n            width: 7px;\n        }\n    }\n    .swiper-pagination{\n        @media screen and (max-width:1000px) {\n            display: flex;\n            padding-left: 36px;\n        }\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n    background: radial-gradient(143.58% 143.58% at -0.00% -0.00%, #717171 0%, #242424 100%);\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    border-radius: 24px;\n    @media screen and (max-width:1000px) {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        display: grid;\n        border-radius: 0;\n        height: 100%;\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    img.mobile{\n        display: none;\n        @media screen and (max-width:1000px) {\n            display: block;\n            width: 320px;\n        }\n    }\n    img.desktop{\n        display: block;\n        @media screen and (max-width:1000px) {\n            display: none;\n        }\n    }\n    @media screen and (max-width:1000px) {\n        align-self: flex-end;\n        justify-self: flex-end;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding-top: 50px;\n    padding-left: 19px;\n    align-items: start;\n    p{\n        color: #ffff;\n        font-style: normal;\n        font-weight: 600;\n        font-size: 10px;\n        line-height: 16px;\n        letter-spacing: 0.9px;\n        text-transform: uppercase;\n        @media screen and (max-width:1000px) {\n            font-size: 8px;\n        }\n    }\n    h3{\n        font-weight: 500;\n        font-size: 32px;\n        line-height: 40px;\n        letter-spacing: -0.5px;\n        color: #FFFFFF;\n        @media screen and (max-width:1000px) {\n            font-size: 20px;\n        }\n    }\n    span{\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 24px;\n        color: #FFFFFF;\n        text-align: left;\n        @media screen and (max-width:1000px) {\n            padding: 14px 0;\n            font-size: 10px;\n        }\n    }\n    a{\n        padding: 10px 15px;\n        font-style: normal;\n        font-weight: 600;\n        font-size: 14px;\n        line-height: 24px;\n        text-align: center;\n        color: #11142D;\n        height: 44px;\n        background: #FFFFFF;\n        border-radius: 12px;\n        margin-top: 3px;\n        @media screen and (max-width:1000px) {\n            border-radius: 25px;\n            font-size: 10px;\n        }\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 1000px;\n    margin: 48px auto;\n    width: 100%;\n    @media screen and (max-width:1000px) {\n        padding:0 20px;\n        margin: 26px auto;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid #E3E3E8;\n    border-radius: 6px;\n    width: 100%;\n    @media screen and (max-width:1000px) {\n        display: grid;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        gap: 15px;\n        border: none;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    border: ",
        ";\n    align-items: center;\n    border-radius: ",
        ";\n    margin: 0;\n    line-height: 40px;\n    border-bottom: ",
        ";\n    height: 56px;\n    width: 100%;\n    @media screen and (max-width:1000px) {\n        padding: 10px 12px;\n        border: 1px solid #E3E3E8;\n        border-radius: 6px;\n        }\n        .after-padding::after{\n            margin-left: 47px !important;\n        }\n    h4{\n        color: #8F8F9B;\n        font-weight: 500;\n        font-size: 14px;\n        /* max-width: 120px;\n        width: 100%; */\n\n\n        @media screen and (max-width:1000px) {\n            display: none;\n        }\n    }\n    @media screen and (max-width: 600px){\n        height: 40px;\n        padding: 4px;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 50px;\n    background: transparent;\n    @media screen and (max-width:1000px) {\n        display: grid;\n        gap: 20px;\n    }\n    @media screen and (max-width:600px) {\n        display: grid;\n        gap: 10px;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n\n    @media screen and (max-width:1000px) {\n        background: #FFFFFF;\n        box-shadow: 0px 4px 32px 12px rgba(210, 210, 210, 0.1);\n        border-radius: 8px;\n        padding: 17px;\n    }\n    @media screen and (max-width:768px) {\n        background: #FFFFFF;\n        box-shadow: 0px 4px 32px 12px rgba(210, 210, 210, 0.1);\n        border-radius: 8px;\n        padding: 10px;\n    }\n    ",
        ",",
        "{\n        display: none;\n        @media screen and (max-width:1000px) {\n            display: block;\n        }\n    }\n\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n    h3{\n        color: #131316;\n        font-weight: 600;\n        font-size: 14px;\n    }\n    p{\n        color: #9C9CAB;\n        font-weight: 600;\n        font-size: 14px;\n    }\n    @media screen and (max-width:1000px) {\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 20px;\n    }\n    \n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    align-items: center;\n    justify-content: flex-start;\n    @media screen and (max-width:600px){\n        gap: 4px;\n    }\n    img{\n        width: 32px;\n        height: 32px;\n        @media screen and (max-width:600px) {\n            width: 22px;\n            height: 22px;\n        }\n        @media screen and (max-width:400px) {\n            width: 18px;\n            height: 18px;\n        }\n    }\n    ",
        "{\n\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 0px;\n        text-align: left;\n        color: #131316;\n\n    }\n    p{\n\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 20px;\n        letter-spacing: 0px;\n        text-align: left;\n        @media screen and (max-width:600px) {\n            font-size:12px;\n\n        }\n        @media screen and (max-width:400px) {\n            font-size:12px;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            width: 120px;\n        }\n    }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    p{\n        @media screen and (max-width:1000px){\n        display: none;\n        }\n    }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    border: 1px solid #E3E3E8;\n    border: ",
        ";\n    padding: 14px 18px 14px 0px;\n    border-radius: 8px;\n    margin-top: 14px;\n    p{\n        margin-bottom: 14px;\n        color: #131316;\n        font-size: 14px;\n        font-weight: 600;\n    }\n    input{\n        border: none;\n        outline: none;\n        padding-left: 12px;\n        width: 100%;\n        background: transparent;\n        color: #131316;\n        font-size: 14px;\n        font-weight: 600;\n        &:focus-visible{\n            border: none;\n        }\n        &::placeholder{\n            color: #131316;\n            font-size: 14px;\n            font-weight: 600;\n        }\n    }\n    @media screen and (max-width: 600px)\n    {\n        padding: 8px 18px 8px 0px;\n        height: 40px;\n    }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding-right: 14px;\n    p{\n        margin-bottom: 0;\n        @media screen  and (max-width:1000px){\n            display: block;\n        }\n        @media screen  and (max-width:600px){\n            font-weight:600\n        }\n    }\n    img{\n        width: 20px;\n        height: 20px;\n    }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 150px;\n    margin-top: 15px;\n    @media screen  and (max-width:1000px){\n        display: none;\n    }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    p{\n        color: #8F8F9B;\n        font-weight: 600;\n        font-size: 14px;\n    }\n    @media screen  and (max-width:1000px){\n        transform: rotate(90deg);\n        margin-bottom: 0;\n        /* width: 20px;\n        height: 20px; */\n        margin: auto;\n        p{\n            display: none;\n        }\n    }\n    @media screen and (max-width:600px) {\n        margin-top: 1rem;\n        margin-bottom: 1rem;\n    }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 328px;\n    height: 48px;\n    background: #E8A23A;\n    border-radius: 8px;\n    @media screen and (max-width:640px) {\n        min-width: 100%;\n        height: 40px;\n        font-size: 13px;\n    }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 40px;\n    justify-content: center;\n    @media screen and (max-width:640px) {\n        margin-top: 20px;\n    }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    outline: none;\n    font-weight: 600;\n    &:focus-visible {\n        outline: none;\n    }\n    ::placeholder {\n        color:",
        ";\n        opacity: 1;\n    }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 48px;\n    height: 48px;\n    border-radius: 100%;\n    display: flex;\n    justify-content:center;\n    cursor: pointer;\n    background: white;\n    box-shadow: rgba(149, 157, 165, 0.1) 0px 8px 24px;\n    &:active{\n        transform: translateY(1px);\n        @media screen  and (max-width:1000px){\n            transform: translateX(1px);\n        }\n    }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}



var CsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-0"
})(_templateObject());
var CsContainerText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-1"
})(_templateObject1());
var CsCarousel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-2"
})(_templateObject2());
var CsItemCarousel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-3"
})(_templateObject3());
var CsRightItemCarousel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-4"
})(_templateObject4());
var CsLeftItemCarousel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-5"
})(_templateObject5());
// CsFormSwap
var CsFormSwap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-6"
})(_templateObject6());
var CsItemField = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-7"
})(_templateObject7());
var CsSelectField = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-8"
})(_templateObject8(), function(param) {
    var noBorder = param.noBorder;
    return noBorder ? "none" : "1px solid #E3E3E8";
}, function(param) {
    var lineBottom = param.lineBottom;
    return lineBottom ? 0 : "6px";
}, function(param) {
    var lineBottom = param.lineBottom;
    return lineBottom ? "1px solid #E3E3E8" : "none";
});
var CsWrapSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-9"
})(_templateObject9());
var CsInputSwapComponent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-10"
})(_templateObject10());
var CsInputSwapRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-11"
})(_templateObject11());
var CsWrapItemField = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-12"
})(_templateObject12(), CsInputSwapComponent, CsInputSwapRight);
var CsBalanceForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-13"
})(_templateObject13());
var CsItemSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-14"
})(_templateObject14(), Text/* default */.Z);
var CsInputField = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-15"
})(_templateObject15());
var CsInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-16"
})(_templateObject16(), function(param) {
    var warming = param.warming;
    return warming ? "1px solid var(--colors-warning43)" : "1px solid #E3E3E8";
});
var CsSuffix = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-17"
})(_templateObject17());
// InputSwap
var CsInputSwap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-18"
})(_templateObject18());
var CsArrowRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-19"
})(_templateObject19());
var CsButtonSwap = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-7a42838d-20"
})(_templateObject20());
var CsWapButtonSwap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-21"
})(_templateObject21());
var CsNumericFormat = (0,styled_components_browser_esm/* default */.ZP)(react_number_format_es/* default */.Z).withConfig({
    componentId: "sc-7a42838d-22"
})(_templateObject22(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsWrapButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a42838d-23"
})(_templateObject23());

;// CONCATENATED MODULE: ./src/views/HomePage/components/Carousel.tsx





var Carousel = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsCarousel, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCarousel, {
            month: "June 2023",
            title: "Hot Hot!!!",
            description: "When switching from another mainnet to Onus mainnet will be supported gas fee",
            titleLink: "Find out more",
            href: "/cross-chains"
        })
    });
};
var ItemCarousel = function(props) {
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemCarousel, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsLeftItemCarousel, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t(props.month)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: t(props.title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t(props.description)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsRightItemCarousel, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "desktop",
                        src: "/images/goldbridge/carousel.png?version=1.0",
                        alt: "Hot Hot!!!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "mobile",
                        src: "/images/goldbridge/carousel-mobile.png?version=1.0",
                        alt: "Hot Hot!!!"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(84453);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(83024);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
// EXTERNAL MODULE: ./src/config/tokenSupport/index.ts
var tokenSupport = __webpack_require__(63061);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(61135);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(96036);
// EXTERNAL MODULE: ./src/config/constants/contracts.ts
var contracts = __webpack_require__(87338);
// EXTERNAL MODULE: ./src/state/index.ts + 50 modules
var state = __webpack_require__(51982);
// EXTERNAL MODULE: ./src/state/cross-chains/actions.ts
var actions = __webpack_require__(74624);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./src/config/api/listApi.ts
var listApi = __webpack_require__(67519);
// EXTERNAL MODULE: ./src/config/abi/erc20.ts + 1 modules
var erc20 = __webpack_require__(56309);
;// CONCATENATED MODULE: ./src/state/cross-chains/fetchData.ts











var fetchDataListAllowanceFromToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
        var dataCurrency, dataTemplate, tokenSupport, spender, account, chainId, balanceOfIsNative, listIsNative, listToken, getAllowance, getBalanceOf, ref, resultAllowance, resultBalanceOf, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    tokenSupport = payload.tokenSupport, spender = payload.spender, account = payload.account, chainId = payload.chainId, balanceOfIsNative = payload.balanceOf;
                    listIsNative = (0,_to_consumable_array/* default */.Z)(tokenSupport).filter(function(item) {
                        return item.isNative;
                    });
                    listToken = (0,_to_consumable_array/* default */.Z)(tokenSupport).filter(function(item) {
                        return !item.isNative;
                    });
                    if (listIsNative.length) {
                        dataCurrency = listIsNative.map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                balanceOf: balanceOfIsNative,
                                allowance: config/* MAX_UINT_256 */.rb,
                                isAllowance: true
                            });
                        });
                    }
                    if (!(listToken === null || listToken === void 0 ? void 0 : listToken.length)) return [
                        3,
                        2
                    ];
                    getAllowance = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var ref, calls, allowance;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        calls = (ref = (0,_to_consumable_array/* default */.Z)(listToken)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                            return {
                                                address: item.address,
                                                name: "allowance",
                                                params: [
                                                    account,
                                                    spender
                                                ]
                                            };
                                        });
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(erc20/* ERC20_ABI */.RB, calls, chainId)
                                        ];
                                    case 1:
                                        allowance = _state.sent();
                                        return [
                                            2,
                                            allowance
                                        ];
                                }
                            });
                        });
                        return function getAllowance() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getBalanceOf = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var ref, calls, balanceOf;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        calls = (ref = (0,_to_consumable_array/* default */.Z)(listToken)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                            return {
                                                address: item.address,
                                                name: "balanceOf",
                                                params: [
                                                    account
                                                ]
                                            };
                                        });
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(erc20/* ERC20_ABI */.RB, calls, chainId)
                                        ];
                                    case 1:
                                        balanceOf = _state.sent();
                                        return [
                                            2,
                                            balanceOf
                                        ];
                                }
                            });
                        });
                        return function getBalanceOf() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        Promise.all([
                            getAllowance(),
                            getBalanceOf()
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), resultAllowance = ref[0], resultBalanceOf = ref[1];
                    dataTemplate = listToken === null || listToken === void 0 ? void 0 : listToken.map(function(item, index) {
                        var allowance = new bignumber/* default */.Z(resultAllowance[index].toString()).dividedBy(new bignumber/* default */.Z(10).pow(listToken[index].decimals)).toNumber();
                        var balanceOf = new bignumber/* default */.Z(resultBalanceOf[index].toString()).dividedBy(new bignumber/* default */.Z(10).pow(listToken[index].decimals)).toNumber();
                        var isAllowance = allowance !== 0;
                        return (0,_object_spread/* default */.Z)({
                            allowance: allowance,
                            isAllowance: isAllowance,
                            balanceOf: balanceOf
                        }, item);
                    });
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        {
                            listAllowanceToken: dataCurrency.concat(dataTemplate)
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listAllowanceToken: []
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataListAllowanceFromToken(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDataListAllowanceToToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
        var dataTemplate, tokenSupport, account, chainId, balanceOfIsNative, listIsNative, listTokenSupport, calls, resultBalanceOf, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    tokenSupport = payload.tokenSupport, account = payload.account, chainId = payload.chainId, balanceOfIsNative = payload.balanceOf;
                    listIsNative = (0,_to_consumable_array/* default */.Z)(tokenSupport).filter(function(item) {
                        return item.isNative;
                    });
                    if (!listIsNative.length) return [
                        3,
                        1
                    ];
                    dataTemplate = listIsNative.map(function(item) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            balanceOf: balanceOfIsNative
                        });
                    });
                    return [
                        3,
                        3
                    ];
                case 1:
                    listTokenSupport = (0,_to_consumable_array/* default */.Z)(tokenSupport).filter(function(item) {
                        return !item.isNative;
                    });
                    calls = (0,_to_consumable_array/* default */.Z)(listTokenSupport).map(function(item) {
                        return {
                            address: item.address,
                            name: "balanceOf",
                            params: [
                                account
                            ]
                        };
                    });
                    return [
                        4,
                        (0,multicall/* default */.Z)(erc20/* ERC20_ABI */.RB, calls, chainId)
                    ];
                case 2:
                    resultBalanceOf = _state.sent();
                    dataTemplate = (0,_to_consumable_array/* default */.Z)(tokenSupport).map(function(item, index) {
                        var balanceOf = new bignumber/* default */.Z(resultBalanceOf[index].toString()).dividedBy(new bignumber/* default */.Z(10).pow(tokenSupport[index].decimals)).toNumber();
                        return (0,_object_spread/* default */.Z)({
                            balanceOf: balanceOf
                        }, item);
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        {
                            listAllowanceToken: dataTemplate
                        }
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listAllowanceToken: []
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataListAllowanceToToken(payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDataToken = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, fromToken, balanceOfFrom, spender) {
        var dataTemplate, getAllowance, getBalanceOf, ref, resultAllowance, resultBalanceOf, allowance, balanceOf, isAllowance, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    if (!fromToken.isNative) return [
                        3,
                        1
                    ];
                    dataTemplate = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fromToken), {
                        balanceOf: balanceOfFrom,
                        allowance: config/* MAX_UINT_256 */.rb,
                        isAllowance: true
                    });
                    return [
                        3,
                        3
                    ];
                case 1:
                    getAllowance = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var allowance;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(erc20/* ERC20_ABI */.RB, [
                                                {
                                                    address: fromToken === null || fromToken === void 0 ? void 0 : fromToken.address,
                                                    name: "allowance",
                                                    params: [
                                                        account,
                                                        spender
                                                    ]
                                                }
                                            ], fromToken === null || fromToken === void 0 ? void 0 : fromToken.chainId)
                                        ];
                                    case 1:
                                        allowance = _state.sent();
                                        return [
                                            2,
                                            allowance
                                        ];
                                }
                            });
                        });
                        return function getAllowance() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getBalanceOf = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var balanceOf;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(erc20/* ERC20_ABI */.RB, [
                                                {
                                                    address: fromToken === null || fromToken === void 0 ? void 0 : fromToken.address,
                                                    name: "balanceOf",
                                                    params: [
                                                        account
                                                    ]
                                                }
                                            ], fromToken === null || fromToken === void 0 ? void 0 : fromToken.chainId)
                                        ];
                                    case 1:
                                        balanceOf = _state.sent();
                                        return [
                                            2,
                                            balanceOf
                                        ];
                                }
                            });
                        });
                        return function getBalanceOf() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        Promise.all([
                            getAllowance(),
                            getBalanceOf()
                        ])
                    ];
                case 2:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), resultAllowance = ref[0], resultBalanceOf = ref[1];
                    allowance = new bignumber/* default */.Z(resultAllowance[0].toString()).dividedBy(new bignumber/* default */.Z(10).pow(fromToken === null || fromToken === void 0 ? void 0 : fromToken.decimals)).toNumber();
                    balanceOf = new bignumber/* default */.Z(resultBalanceOf[0].toString()).dividedBy(new bignumber/* default */.Z(10).pow(fromToken === null || fromToken === void 0 ? void 0 : fromToken.decimals)).toNumber();
                    isAllowance = allowance !== 0;
                    dataTemplate = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fromToken), {
                        balanceOf: balanceOf,
                        allowance: allowance,
                        isAllowance: isAllowance
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        dataTemplate
                    ];
                case 4:
                    error = _state.sent();
                    return [
                        2,
                        {}
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataToken(account, fromToken, balanceOfFrom, spender) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDataCrossChain = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var res, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        listApi/* listApi.crossChain */.Z.crossChain()
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        2,
                        {
                            dataCrossChain: res === null || res === void 0 ? void 0 : res.data
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listHistory: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataCrossChain() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(69352);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/hooks/useCallWithMarketGasPrice.ts
var useCallWithMarketGasPrice = __webpack_require__(31063);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 4 modules
var useContract = __webpack_require__(10432);
;// CONCATENATED MODULE: ./src/hooks/use-cross-chains.tsx



















var useCrossChains = function(fillAmount, toChain, fromToken, toToken) {
    var ref, ref1, ref2, ref3;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var t = (0,src/* useTranslation */.$G)().t;
    var ref4 = (0,useToast/* useToast */.p)(), toastSuccess = ref4.toastSuccess, toastError = ref4.toastError;
    var ref5 = (0,useActiveWeb3React/* default */.Z)(), chainId = ref5.chainId, account = ref5.account;
    var nativeBalanceFrom = (0,dist/* useBalance */.KQ)({
        address: account,
        chainId: fromToken === null || fromToken === void 0 ? void 0 : fromToken.chainId
    });
    var nativeBalanceTo = (0,dist/* useBalance */.KQ)({
        address: account,
        chainId: toToken === null || toToken === void 0 ? void 0 : toToken.chainId
    });
    var balanceOfFrom = new bignumber/* default */.Z(nativeBalanceFrom === null || nativeBalanceFrom === void 0 ? void 0 : (ref = nativeBalanceFrom.data) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.toString()).dividedBy(1E18).toNumber();
    var balanceOfTo = new bignumber/* default */.Z(nativeBalanceTo === null || nativeBalanceTo === void 0 ? void 0 : (ref2 = nativeBalanceTo.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.value) === null || ref3 === void 0 ? void 0 : ref3.toString()).dividedBy(1E18).toNumber();
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var resultStoreCrossChains = (0,state/* useAppSelector */.CG)(state/* storeCrossChains */.W_);
    var ContractBrideAddress = (0,addressHelpers/* getAddress */.Kn)(contracts/* default.bridge */.Z.bridge, chainId);
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), loadingTx = ref6[0], setLoadingTx = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), dataFromToken = ref7[0], setDataFromToken = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), dataToToken = ref8[0], setDataToToken = ref8[1];
    var addressApprove = (0,useContract/* useCsERC20 */.cn)(fromToken === null || fromToken === void 0 ? void 0 : fromToken.address);
    var swapContract = (0,useContract/* useSwap */.ZD)(ContractBrideAddress);
    var handleDataToken = react.useCallback(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var resultFromToken, resultToToken;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchDataToken(account, fromToken, balanceOfFrom, ContractBrideAddress)
                    ];
                case 1:
                    resultFromToken = _state.sent();
                    return [
                        4,
                        fetchDataToken(account, toToken, balanceOfTo, ContractBrideAddress)
                    ];
                case 2:
                    resultToToken = _state.sent();
                    setDataFromToken(resultFromToken);
                    setDataToToken(resultToToken);
                    return [
                        2
                    ];
            }
        });
    }), [
        ContractBrideAddress,
        account,
        balanceOfFrom,
        balanceOfTo,
        fromToken,
        toToken
    ]);
    var handleApproveToken = react.useCallback(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tx, receipt, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoadingTx(!false);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        7
                    ]);
                    return [
                        4,
                        callWithMarketGasPrice(addressApprove, "approve", [
                            ContractBrideAddress,
                            bignumbers/* MaxUint256 */.Bz
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("Contract enabel"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                    } else {
                        toastError(t("Error"), t("Please try again. Confirm the transaction and make sure you are paying enough gas!"));
                    }
                    return [
                        3,
                        7
                    ];
                case 4:
                    error = _state.sent();
                    console.log(error);
                    toastError(t("Error"), t("Please try again. Transaction confirmation failed"));
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        handleDataToken()
                    ];
                case 6:
                    _state.sent();
                    setLoadingTx(false);
                    return [
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    }), [
        ContractBrideAddress,
        addressApprove,
        callWithMarketGasPrice,
        handleDataToken,
        t,
        toastError,
        toastSuccess
    ]);
    var handleSwap = react.useCallback(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var conVerSwapAmount, tx, receipt, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    conVerSwapAmount = new bignumber/* default */.Z(fillAmount).multipliedBy(new bignumber/* default */.Z(10).pow(fromToken === null || fromToken === void 0 ? void 0 : fromToken.decimals)).toString();
                    setLoadingTx(!false);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        10
                    ]);
                    if (!(fromToken === null || fromToken === void 0 ? void 0 : fromToken.isNative)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        callWithMarketGasPrice(swapContract, "depositNative", [
                            toChain
                        ], {
                            value: conVerSwapAmount
                        })
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        callWithMarketGasPrice(swapContract, "deposit", [
                            fromToken === null || fromToken === void 0 ? void 0 : fromToken.address,
                            conVerSwapAmount,
                            toChain
                        ])
                    ];
                case 4:
                    tx = _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        tx.wait()
                    ];
                case 6:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("Swap successful"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                    } else {
                        toastError(t("Error"), t("Please try again. Confirm the transaction and make sure you are paying enough gas!"));
                    }
                    return [
                        3,
                        10
                    ];
                case 7:
                    error = _state.sent();
                    console.log(error);
                    toastError(t("Error"), t("Please try again. Transaction confirmation failed"));
                    return [
                        3,
                        10
                    ];
                case 8:
                    return [
                        4,
                        handleDataToken()
                    ];
                case 9:
                    _state.sent();
                    setLoadingTx(false);
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    }), [
        callWithMarketGasPrice,
        fillAmount,
        fromToken === null || fromToken === void 0 ? void 0 : fromToken.address,
        fromToken === null || fromToken === void 0 ? void 0 : fromToken.decimals,
        fromToken === null || fromToken === void 0 ? void 0 : fromToken.isNative,
        handleDataToken,
        swapContract,
        t,
        toChain,
        toastError,
        toastSuccess
    ]);
    react.useEffect(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var crossChain;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchDataCrossChain()
                        ];
                    case 1:
                        crossChain = _state.sent();
                        dispatch((0,actions/* getDataCrossChain */.jU)({
                            data: crossChain
                        }));
                        return [
                            4,
                            handleDataToken()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        chainId,
        dispatch,
        handleDataToken,
        toChain
    ]);
    react.useEffect(function() {
        var timer = setInterval(function() {
            (0,_async_to_generator/* default */.Z)(function() {
                var crossChain;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchDataCrossChain()
                            ];
                        case 1:
                            crossChain = _state.sent();
                            dispatch((0,actions/* getDataCrossChain */.jU)({
                                data: crossChain
                            }));
                            return [
                                2
                            ];
                    }
                });
            })();
        }, 60000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        dispatch,
        handleDataToken
    ]);
    return {
        dataFromToken: dataFromToken,
        dataToToken: dataToToken,
        handleApproveToken: handleApproveToken,
        handleSwap: handleSwap,
        resultStoreCrossChains: resultStoreCrossChains,
        account: account,
        chainId: chainId,
        loadingTx: loadingTx
    };
};

;// CONCATENATED MODULE: ./src/hooks/index.ts


// EXTERNAL MODULE: ./src/hooks/useSwitchNetwork.ts
var useSwitchNetwork = __webpack_require__(85240);
;// CONCATENATED MODULE: ./src/views/HomePage/components/BalanceForm.tsx




var BalanceForm = function(param) {
    var title = param.title, value = param.value;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsBalanceForm, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: t(title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    t("Balance"),
                    ": ",
                    value
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/HomePage/components/InputLeft.tsx





var imgUSDT = "/images/coins/usdt.png";
var InputLeft = function(param) {
    var balanceForFrom = param.balanceForFrom, fillAmount = param.fillAmount, onChangeAmount = param.onChangeAmount, symbol = param.symbol, isMinAmount = param.isMinAmount, isMaxAmount = param.isMaxAmount, minAmount = param.minAmount, maxAmount = param.maxAmount, isNotBalanceToTransfer = param.isNotBalanceToTransfer, childrenPercent = param.childrenPercent;
    var ref, ref1;
    var t = (0,src/* useTranslation */.$G)().t;
    var renderImg = (0,react.useMemo)(function() {
        return "/images/coins/".concat(symbol === null || symbol === void 0 ? void 0 : symbol.toLowerCase(), ".png");
    }, [
        symbol
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsInputSwapComponent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsInputField, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[#131316] font-semibold text-[14px]",
                                children: t("Amount")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[#8F8F9B] font-semibold text-[14px]",
                                children: [
                                    t("Balance"),
                                    ": ",
                                    balanceForFrom
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsInput, {
                        warming: isMinAmount || isMaxAmount || isNotBalanceToTransfer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsNumericFormat, {
                                value: fillAmount,
                                decimalScale: 6,
                                thousandSeparator: true,
                                placeholder: fillAmount || "0.0",
                                // eslint-disable-next-line no-return-assign, no-param-reassign
                                onFocus: function(e) {
                                    return e.target.placeholder = "";
                                },
                                onValueChange: function(values) {
                                    var value = values.value;
                                    if (Number(value) >= 0) {
                                        onChangeAmount(value);
                                    }
                                },
                                maxLength: 35,
                                allowNegative: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsSuffix, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "sm:w-[32px] sm:h-[32px] w-6 h-6",
                                        src: symbol ? renderImg : imgUSDT,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sm:text-sm text-xs",
                                        children: symbol || "USDT"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (isMinAmount || isMaxAmount) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                mt: "14px",
                fontSize: "14px",
                fontWeight: 600,
                color: "warning43",
                children: [
                    isMinAmount && t("The crosschain amount must be greater than %min% %token%", {
                        min: (ref = Number(minAmount)) === null || ref === void 0 ? void 0 : ref.toLocaleString("en", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2
                        }),
                        token: symbol
                    }),
                    isMaxAmount && t("The crosschain amount must be less than %max% %token%", {
                        max: (ref1 = Number(maxAmount)) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString("en", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2
                        }),
                        token: symbol
                    })
                ]
            }),
            isNotBalanceToTransfer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mt: "14px",
                fontSize: "14px",
                fontWeight: 600,
                color: "warning43",
                children: t("Your assets are not enough")
            }),
            childrenPercent
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/HomePage/components/InputRight.tsx




var InputRight_imgUSDT = "/images/coins/usdt.png";
var InputRight = function(param) {
    var fillAmount = param.fillAmount, symbol = param.symbol, balance = param.balance;
    var t = (0,src/* useTranslation */.$G)().t;
    var renderImg = (0,react.useMemo)(function() {
        return "/images/coins/".concat(symbol === null || symbol === void 0 ? void 0 : symbol.toLowerCase(), ".png");
    }, [
        symbol
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsInputSwapComponent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsInputField, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[#131316] font-bold text-[14px]",
                            children: t("Amount")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-[#8F8F9B] font-bold text-[14px]",
                            children: [
                                t("Balance"),
                                ": ",
                                balance
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsInput, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsNumericFormat, {
                            value: fillAmount,
                            decimalScale: 6,
                            thousandSeparator: !false,
                            maxLength: 35,
                            allowNegative: false,
                            readOnly: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsSuffix, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "sm:w-[32px] sm:h-[32px] w-6 h-6",
                                    src: symbol ? renderImg : InputRight_imgUSDT,
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "sm:text-sm text-xs",
                                    children: symbol || "USDT"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/views/HomePage/components/Note.tsx


var Note = function(param) {
    var feePercent = param.feePercent, addressToSymbol = param.addressToSymbol, feeMin = param.feeMin;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row lg:mt-[60px] mt-[40px] md:gap-[18px] gap-[0px] bg-[#FFFCF8] mb-0 md:mb-[41px] mb-0 md:p-[20px] p-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-[6px] pe-[8px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            opacity: "0.4",
                            d: "M12.0001 7.89001L10.9301 9.75001C10.6901 10.16 10.8901 10.5 11.3601 10.5H12.6301C13.1101 10.5 13.3001 10.84 13.0601 11.25L12.0001 13.11",
                            stroke: "#E8A23A",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M8.29986 18.04V16.88C5.99986 15.49 4.10986 12.78 4.10986 9.89999C4.10986 4.94999 8.65986 1.06999 13.7999 2.18999C16.0599 2.68999 18.0399 4.18999 19.0699 6.25999C21.1599 10.46 18.9599 14.92 15.7299 16.87V18.03C15.7299 18.32 15.8399 18.99 14.7699 18.99H9.25986C8.15986 19 8.29986 18.57 8.29986 18.04Z",
                            stroke: "#E8A23A",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            opacity: "0.4",
                            d: "M8.5 22C10.79 21.35 13.21 21.35 15.5 22",
                            stroke: "#E8A23A",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "basis-11/12 p-[10px] md:p-0 flex justify-center flex-col py-[6px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-[#23262F] lg:text-[24px] text-[18px] font-bold mb-1",
                        children: t("Note")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[#777E91] lg:text-sm font-medium text-[12px]",
                        children: t("Crosschain Fee is (%percent% or %feeMin% %symbol% )", {
                            percent: feePercent !== undefined ? "".concat(feePercent, "%") : "0%",
                            feeMin: feeMin !== undefined ? "".concat(feeMin) : "0",
                            symbol: addressToSymbol
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[#777E91] lg:text-sm font-medium text-[12px]",
                        children: t("Estimated Time of Crosschain Arrival is 3s-1min")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[#777E91] lg:text-sm font-medium text-[12px]",
                        children: t("Crosschain amount larger than 1,000,000 %symbol% could take up to 24 hours", {
                            symbol: addressToSymbol
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/HomePage/components/PercentPrice.tsx



var PercentPrice = function(param) {
    var setFillAmount = param.setFillAmount, balanceFrom = param.balanceFrom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex gap-[10px] lg:mt-4 mt-[10px]",
        children: config/* PERCENT_PRICE.map */.x0.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                "aria-hidden": "true",
                onClick: function() {
                    if (balanceFrom) {
                        setFillAmount(new bignumber/* default */.Z(item.value).multipliedBy(balanceFrom).decimalPlaces(4, 1).toString());
                    }
                },
                className: "bg-[#e8a23a1a] lg:px-4 px-3 lx:py-1 py-[6px] rounded-[30px] text-[#E8A23A] lg:text-sm text-xs cursor-pointer hover:bg-[#E8A23A] hover:text-white font-bold transition duration-150 ease-in-out",
                children: item.title
            }, item.value);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/antd/es/dropdown/index.js + 165 modules
var dropdown = __webpack_require__(78261);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(39917);
;// CONCATENATED MODULE: ./src/views/HomePage/components/SelectAssetField.tsx





var SelectAssetField = function(param) {
    var label = param.label, _options = param.options, options = _options === void 0 ? [] : _options, noBorder = param.noBorder, lineBottom = param.lineBottom, onChangeToken = param.onChangeToken, selectedToken = param.selectedToken, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled;
    var handleChange = function(value) {
        onChangeToken(value);
    };
    if (options.length === 0) return null;
    var items = options === null || options === void 0 ? void 0 : options.map(function(item, index) {
        var ref;
        return {
            key: index,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 items-center gap-6 md:py-2 py-0",
                onClick: function() {
                    return handleChange(item);
                },
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/coins/".concat(item.symbol.toLowerCase(), ".png?version=4.0"),
                        alt: item.name,
                        className: "sm:w-[32px] sm:h-[32px] w-6 h-6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m["default"])("font-semibold sm:text-sm text-xs truncate", (selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.toLowerCase()) !== (item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) ? "text-[#131316]" : "text-[#9C9CAB]"),
                        children: item.name
                    })
                ]
            })
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsSelectField, {
        noBorder: noBorder,
        lineBottom: lineBottom,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
            trigger: [
                "click"
            ],
            menu: {
                items: items
            },
            className: "w-full",
            overlayStyle: {
                borderRadius: "8px",
                border: "1px solid #E3E3E8"
            },
            disabled: isDisabled,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsContainerText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full items-center cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[7px] w-full items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/coins/".concat(selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.toLowerCase(), ".png?version=4.0"),
                                        alt: selectedToken,
                                        className: "sm:w-[32px] sm:h-[32px] w-6 h-6"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#131316] sm:text-sm text-xs truncate font-bold",
                                        children: selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.toUpperCase()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {
                                className: "sm:mr-6 mr-0"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/utils/wagmi.ts + 113 modules
var wagmi = __webpack_require__(49761);
;// CONCATENATED MODULE: ./src/views/HomePage/components/SelectFromField.tsx






var SelectFromField = function(param) {
    var label = param.label, _options = param.options, options = _options === void 0 ? [] : _options, noBorder = param.noBorder, lineBottom = param.lineBottom, onChange = param.onChange, name = param.name, chainId = param.chainId, selectFromChain = param.selectFromChain;
    var handleChange = function(id) {
        onChange(id);
    };
    var renderChainName = function(newChainId) {
        if (chainId) {
            var findData = wagmi/* CHAINS.find */.zG.find(function(ch) {
                return (ch === null || ch === void 0 ? void 0 : ch.id) === newChainId;
            });
            return findData === null || findData === void 0 ? void 0 : findData.name;
        }
        return null;
    };
    var items = options.map(function(item, index) {
        var ref, ref1;
        return {
            key: index,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 items-center gap-6 md:py-2 py-0",
                onClick: function() {
                    return handleChange(item.chainId);
                },
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/chains/".concat(item === null || item === void 0 ? void 0 : (ref = item.chainId) === null || ref === void 0 ? void 0 : ref.toString(), ".png?version=4.0"),
                        alt: item === null || item === void 0 ? void 0 : (ref1 = item.chainId) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                        className: "sm:w-[32px] sm:h-[32px] w-6 h-6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m["default"])("font-bold sm:text-sm text-xs truncate", chainId !== item.chainId ? "text-[#131316]" : "text-[#9C9CAB]"),
                        children: renderChainName(item.chainId)
                    })
                ]
            })
        };
    });
    var findData = wagmi/* CHAINS.find */.zG.find(function(ch) {
        return (ch === null || ch === void 0 ? void 0 : ch.id) === selectFromChain;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsSelectField, {
        noBorder: noBorder,
        lineBottom: lineBottom,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
            trigger: [
                "click"
            ],
            menu: {
                items: items
            },
            className: "w-full",
            overlayStyle: {
                borderRadius: "8px",
                border: "1px solid #E3E3E8"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsContainerText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: label
                        })
                    }),
                    findData && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full items-center cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[7px] w-full items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/chains/".concat(selectFromChain.toString(), ".png?version=5.0"),
                                        alt: selectFromChain === null || selectFromChain === void 0 ? void 0 : selectFromChain.toString(),
                                        className: "sm:w-[32px] sm:h-[32px] w-6 h-6"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#131316] sm:text-sm text-xs truncate font-normal",
                                        children: renderChainName(selectFromChain)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {
                                className: "sm:mr-6 mr-0"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/views/HomePage/components/SelectToField.tsx






var SelectToField = function(param) {
    var label = param.label, _options = param.options, options = _options === void 0 ? [] : _options, noBorder = param.noBorder, lineBottom = param.lineBottom, onChange = param.onChange, name = param.name, chainId = param.chainId, toChainId = param.toChainId;
    var handleChange = function(value) {
        onChange(Number(value));
    };
    var renderChainName = function(newChainId) {
        var findData = wagmi/* CHAINS.find */.zG.find(function(dt) {
            return (dt === null || dt === void 0 ? void 0 : dt.id) === newChainId;
        });
        return findData === null || findData === void 0 ? void 0 : findData.name;
    };
    var items = options.map(function(item, index) {
        var ref, ref1;
        return {
            key: index,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-1 items-center gap-6 md:py-2 py-0",
                onClick: function() {
                    return handleChange(item === null || item === void 0 ? void 0 : item.chainId);
                },
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/chains/".concat(item === null || item === void 0 ? void 0 : (ref = item.chainId) === null || ref === void 0 ? void 0 : ref.toString(), ".png?version=4.0"),
                        alt: (ref1 = item.chainId) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                        className: "w-[32px] h-[32px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m["default"])("font-semibold text-sm", toChainId === item.chainId ? "text-[#131316]" : "text-[#9C9CAB]"),
                        children: renderChainName(item.chainId)
                    })
                ]
            })
        };
    });
    var findData = wagmi/* CHAINS.find */.zG.find(function(ch) {
        return (ch === null || ch === void 0 ? void 0 : ch.id) === toChainId;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsSelectField, {
        noBorder: noBorder,
        lineBottom: lineBottom,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
            trigger: [
                "click"
            ],
            menu: {
                items: items
            },
            className: "w-full",
            overlayStyle: {
                borderRadius: "8px",
                border: "1px solid #E3E3E8"
            },
            disabled: (options === null || options === void 0 ? void 0 : options.length) === 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsContainerText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: label
                        })
                    }),
                    findData && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full items-center cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-[7px] w-full items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/chains/".concat(findData.id, ".png?version=5.0"),
                                        alt: findData.name,
                                        className: "sm:w-[32px] sm:h-[32px] w-6 h-6"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#131316] sm:text-sm text-xs truncate",
                                        children: findData.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {
                                className: "sm:mr-6 mr-0"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var swap_sdk_src = __webpack_require__(1505);
;// CONCATENATED MODULE: ./src/views/HomePage/components/NoteSupport.tsx



var NoteSupport = function(param) {
    var toChain = param.toChain, findTokenTo = param.findTokenTo, bonus = param.bonus, amountMinBonus = param.amountMinBonus;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: toChain === swap_sdk_src/* ChainId.ONUS */.a_.ONUS && Boolean(amountMinBonus) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "text-[13px] text-[#131316] tracking-wide font-bold mt-[14px] pl-[18px] lg:ps-[78px] lg:ms-[50%]",
            children: t("Crosschain amount larger than %amount% %symbol% will support %support% ONUS", {
                amount: amountMinBonus,
                symbol: findTokenTo === null || findTokenTo === void 0 ? void 0 : findTokenTo.symbol,
                support: bonus || "0.01"
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/views/HomePage/components/FormSwap.tsx
























var FormSwap = function(param) {
    var onHandleChangeFee = param.onHandleChangeFee;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,useActiveWeb3React/* default */.Z)(), chainId = ref7.chainId, account = ref7.account;
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), selectToken = ref8[0], setSelectToken = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), selectFromChain = ref9[0], setSelectFromChain = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), toChain = ref10[0], setToChain = ref10[1];
    var switchNetworkAsync = (0,dist/* useSwitchNetwork */.g0)().switchNetworkAsync;
    var switchNetworkLocal = (0,useSwitchNetwork/* useSwitchNetworkLocal */.n)();
    var ref11 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), fillAmount = ref11[0], setFillAmount = ref11[1];
    var findTokenFrom = react.useMemo(function() {
        var ref;
        return (ref = selectToken === null || selectToken === void 0 ? void 0 : selectToken.fromChains.find(function(dt) {
            return (dt === null || dt === void 0 ? void 0 : dt.chainId) === chainId;
        })) === null || ref === void 0 ? void 0 : ref.token;
    }, [
        chainId,
        selectToken === null || selectToken === void 0 ? void 0 : selectToken.fromChains
    ]);
    var findTokenTo = react.useMemo(function() {
        var ref;
        return (ref = selectToken === null || selectToken === void 0 ? void 0 : selectToken.fromChains.find(function(dt) {
            return (dt === null || dt === void 0 ? void 0 : dt.chainId) === toChain;
        })) === null || ref === void 0 ? void 0 : ref.token;
    }, [
        selectToken === null || selectToken === void 0 ? void 0 : selectToken.fromChains,
        toChain
    ]);
    var t = (0,src/* useTranslation */.$G)().t;
    var ref12 = useCrossChains(fillAmount, toChain, findTokenFrom, findTokenTo), handleApproveToken = ref12.handleApproveToken, handleSwap = ref12.handleSwap, resultStoreCrossChains = ref12.resultStoreCrossChains, loadingTx = ref12.loadingTx, dataFromToken = ref12.dataFromToken;
    var data = resultStoreCrossChains.data;
    var checkIsApproved = react.useMemo(function() {
        if (new bignumber/* default */.Z(dataFromToken === null || dataFromToken === void 0 ? void 0 : dataFromToken.allowance).isGreaterThanOrEqualTo(fillAmount) || new bignumber/* default */.Z(dataFromToken === null || dataFromToken === void 0 ? void 0 : dataFromToken.allowance).isGreaterThan(0) && new bignumber/* default */.Z(fillAmount).isNaN()) return true;
        return false;
    }, [
        fillAmount,
        dataFromToken === null || dataFromToken === void 0 ? void 0 : dataFromToken.allowance
    ]);
    var handleAction = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!checkIsApproved) return [
                            3,
                            1
                        ];
                        handleApproveToken();
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            handleSwap()
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAction() {
            return _ref.apply(this, arguments);
        };
    }();
    // initial data
    react.useLayoutEffect(function() {
        var ref, ref1, ref2;
        var initial = tokenSupport.listTokens.find(function(dt) {
            var ref;
            return dt === null || dt === void 0 ? void 0 : (ref = dt.fromChains) === null || ref === void 0 ? void 0 : ref.find(function(it) {
                return (it === null || it === void 0 ? void 0 : it.chainId) === chainId;
            });
        });
        setSelectToken(initial);
        setSelectFromChain((ref1 = initial === null || initial === void 0 ? void 0 : (ref = initial.fromChains) === null || ref === void 0 ? void 0 : ref.find(function(dt) {
            return (dt === null || dt === void 0 ? void 0 : dt.chainId) === chainId;
        })) === null || ref1 === void 0 ? void 0 : ref1.chainId);
        var fistFromChain = initial === null || initial === void 0 ? void 0 : (ref2 = initial.fromChains) === null || ref2 === void 0 ? void 0 : ref2.find(function(dt) {
            return (dt === null || dt === void 0 ? void 0 : dt.chainId) !== chainId;
        });
        setToChain(fistFromChain === null || fistFromChain === void 0 ? void 0 : fistFromChain.chainId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var dataTokenTransfer = react.useMemo(function() {
        try {
            var ref, ref1, ref2;
            var tokenTransferInfo = data === null || data === void 0 ? void 0 : data.dataCrossChain[dataFromToken === null || dataFromToken === void 0 ? void 0 : dataFromToken.symbol];
            var sourceChain = tokenTransferInfo === null || tokenTransferInfo === void 0 ? void 0 : tokenTransferInfo.find(function(dt) {
                return Number(dt === null || dt === void 0 ? void 0 : dt.chainid_source) === chainId && Number(dt === null || dt === void 0 ? void 0 : dt.chainid_destination) === toChain;
            });
            var destinationChain = tokenTransferInfo === null || tokenTransferInfo === void 0 ? void 0 : tokenTransferInfo.find(function(dt) {
                return Number(dt === null || dt === void 0 ? void 0 : dt.chainid_destination) === toChain;
            });
            var isMintAmountTransfer = new bignumber/* default */.Z(fillAmount).isLessThan(sourceChain === null || sourceChain === void 0 ? void 0 : sourceChain.min_amount);
            var isMaxAmountTransfer = new bignumber/* default */.Z(fillAmount).isGreaterThan(sourceChain === null || sourceChain === void 0 ? void 0 : sourceChain.max_amount);
            var minAmount = sourceChain === null || sourceChain === void 0 ? void 0 : sourceChain.min_amount;
            var maxAmount = sourceChain === null || sourceChain === void 0 ? void 0 : sourceChain.max_amount;
            var rate = destinationChain === null || destinationChain === void 0 ? void 0 : destinationChain.rate_swap;
            var ref3;
            var isActive = (ref3 = (sourceChain === null || sourceChain === void 0 ? void 0 : sourceChain.status) === "enable") !== null && ref3 !== void 0 ? ref3 : false;
            var feePercent = sourceChain === null || sourceChain === void 0 ? void 0 : (ref = sourceChain.fee) === null || ref === void 0 ? void 0 : ref.fee_percent;
            var feeMin = sourceChain === null || sourceChain === void 0 ? void 0 : (ref1 = sourceChain.fee) === null || ref1 === void 0 ? void 0 : ref1.fee_min;
            onHandleChangeFee(sourceChain === null || sourceChain === void 0 ? void 0 : (ref2 = sourceChain.fee) === null || ref2 === void 0 ? void 0 : ref2.fee_percent);
            return {
                isMintAmountTransfer: isMintAmountTransfer,
                isMaxAmountTransfer: isMaxAmountTransfer,
                rate: rate,
                minAmount: minAmount,
                maxAmount: maxAmount,
                feePercent: feePercent,
                feeMin: feeMin,
                bonus: destinationChain === null || destinationChain === void 0 ? void 0 : destinationChain.amount_bonus,
                amountMinBonus: destinationChain === null || destinationChain === void 0 ? void 0 : destinationChain.amount_min_bonus,
                isActive: isActive
            };
        } catch (error) {
            return {
                isMintAmountTransfer: false,
                isMaxAmountTransfer: false,
                minAmount: "0",
                maxAmount: "0",
                feePercent: "0",
                feeMin: "0",
                amountMinBonus: null,
                isActive: false
            };
        }
    }, [
        chainId,
        data === null || data === void 0 ? void 0 : data.dataCrossChain,
        fillAmount,
        dataFromToken === null || dataFromToken === void 0 ? void 0 : dataFromToken.symbol,
        onHandleChangeFee,
        toChain
    ]);
    var isMintAmountTransfer = dataTokenTransfer.isMintAmountTransfer, isMaxAmountTransfer = dataTokenTransfer.isMaxAmountTransfer, rate = dataTokenTransfer.rate, minAmount = dataTokenTransfer.minAmount, maxAmount = dataTokenTransfer.maxAmount, feePercent = dataTokenTransfer.feePercent, bonus = dataTokenTransfer.bonus, feeMin = dataTokenTransfer.feeMin, amountMinBonus = dataTokenTransfer.amountMinBonus;
    var actuallyReceived = react.useMemo(function() {
        if (new bignumber/* default */.Z(fillAmount).isNaN() || new bignumber/* default */.Z(rate).isNaN() || new bignumber/* default */.Z(feePercent).isNaN()) return "0.0";
        var inflation = new bignumber/* default */.Z(fillAmount).multipliedBy(0.01).toString();
        var priceInflation = new bignumber/* default */.Z(fillAmount).minus(inflation).toString();
        var priceRate = new bignumber/* default */.Z(priceInflation).multipliedBy(rate).toString();
        var pricePercent = new bignumber/* default */.Z(priceRate).multipliedBy(new bignumber/* default */.Z(feePercent).dividedBy(100)).toString();
        var fee = new bignumber/* default */.Z(pricePercent).isLessThan(feeMin) ? feeMin : pricePercent;
        var resultPrice = new bignumber/* default */.Z(priceRate).minus(fee).decimalPlaces(4, 1).toString();
        return resultPrice;
    }, [
        feeMin,
        feePercent,
        fillAmount,
        rate
    ]);
    var balanceFrom = account ? new bignumber/* default */.Z(dataFromToken === null || dataFromToken === void 0 ? void 0 : dataFromToken.balanceOf) : new bignumber/* default */.Z(0);
    var renderBalanceFrom = (balanceFrom === null || balanceFrom === void 0 ? void 0 : balanceFrom.isEqualTo(0)) || (balanceFrom === null || balanceFrom === void 0 ? void 0 : balanceFrom.isNaN()) || !account ? "0.0" : balanceFrom === null || balanceFrom === void 0 ? void 0 : balanceFrom.decimalPlaces(4, 1).toString();
    var handleSwapChain = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        if (!account) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            switchNetworkAsync(toChain)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            switchNetworkLocal(toChain)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        setSelectFromChain(toChain);
                        setToChain(selectFromChain);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSwapChain() {
            return _ref.apply(this, arguments);
        };
    }();
    var balanceToNative = (0,dist/* useBalance */.KQ)({
        address: account,
        chainId: findTokenTo === null || findTokenTo === void 0 ? void 0 : findTokenTo.chainId,
        staleTime: 60000
    });
    var balanceTo = (0,dist/* useBalance */.KQ)({
        address: account,
        chainId: findTokenTo === null || findTokenTo === void 0 ? void 0 : findTokenTo.chainId,
        token: findTokenTo === null || findTokenTo === void 0 ? void 0 : findTokenTo.address,
        staleTime: 60000
    });
    var nativeBalanceFrom = (0,dist/* useBalance */.KQ)({
        address: account,
        chainId: findTokenFrom === null || findTokenFrom === void 0 ? void 0 : findTokenFrom.chainId,
        staleTime: 60000
    });
    var checkBalanceTo = (findTokenTo === null || findTokenTo === void 0 ? void 0 : findTokenTo.isNative) ? (ref1 = new bignumber/* default */.Z((balanceToNative === null || balanceToNative === void 0 ? void 0 : (ref = balanceToNative.data) === null || ref === void 0 ? void 0 : ref.formatted) || 0)) === null || ref1 === void 0 ? void 0 : ref1.decimalPlaces(4, 1).toString() : (ref3 = new bignumber/* default */.Z((balanceTo === null || balanceTo === void 0 ? void 0 : (ref2 = balanceTo.data) === null || ref2 === void 0 ? void 0 : ref2.formatted) || 0)) === null || ref3 === void 0 ? void 0 : ref3.decimalPlaces(4, 1).toString();
    var checkBalanceFrom = (findTokenFrom === null || findTokenFrom === void 0 ? void 0 : findTokenFrom.isNative) ? (ref5 = new bignumber/* default */.Z(nativeBalanceFrom === null || nativeBalanceFrom === void 0 ? void 0 : (ref4 = nativeBalanceFrom.data) === null || ref4 === void 0 ? void 0 : ref4.formatted)) === null || ref5 === void 0 ? void 0 : ref5.decimalPlaces(4, 1).toString() : renderBalanceFrom;
    var isNotBalanceToTransfer = react.useMemo(function() {
        return new bignumber/* default */.Z(fillAmount).isGreaterThan(checkBalanceFrom);
    }, [
        fillAmount,
        checkBalanceFrom
    ]);
    react.useEffect(function() {
        setFillAmount("");
    }, [
        checkBalanceFrom
    ]);
    var handleSelectToken = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newToken) {
            var initial, ref, findItem, ref1, ref2, ref3, ref4, ref5, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        initial = tokenSupport.listTokens.find(function(dt) {
                            return (dt === null || dt === void 0 ? void 0 : dt.name) === (newToken === null || newToken === void 0 ? void 0 : newToken.name);
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        findItem = initial === null || initial === void 0 ? void 0 : (ref = initial.fromChains) === null || ref === void 0 ? void 0 : ref.find(function(dt) {
                            return (dt === null || dt === void 0 ? void 0 : dt.chainId) === chainId;
                        });
                        if (!!findItem) return [
                            3,
                            4
                        ];
                        if (!account) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            switchNetworkAsync((ref1 = initial === null || initial === void 0 ? void 0 : initial.fromChains[0]) === null || ref1 === void 0 ? void 0 : ref1.chainId)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        switchNetworkLocal((ref2 = initial === null || initial === void 0 ? void 0 : initial.fromChains[0]) === null || ref2 === void 0 ? void 0 : ref2.chainId);
                        _state.label = 4;
                    case 4:
                        setSelectToken(newToken);
                        if (findItem) {
                            ;
                            setToChain((ref3 = initial === null || initial === void 0 ? void 0 : initial.toChains.find(function(dt) {
                                return (dt === null || dt === void 0 ? void 0 : dt.chainId) !== chainId;
                            })) === null || ref3 === void 0 ? void 0 : ref3.chainId);
                            setSelectFromChain(chainId);
                        } else {
                            ;
                            setToChain((ref4 = initial === null || initial === void 0 ? void 0 : initial.toChains.find(function(dt) {
                                var ref;
                                return (dt === null || dt === void 0 ? void 0 : dt.chainId) !== ((ref = initial === null || initial === void 0 ? void 0 : initial.fromChains[0]) === null || ref === void 0 ? void 0 : ref.chainId);
                            })) === null || ref4 === void 0 ? void 0 : ref4.chainId);
                            setSelectFromChain((ref5 = initial === null || initial === void 0 ? void 0 : initial.fromChains[0]) === null || ref5 === void 0 ? void 0 : ref5.chainId);
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectToken(newToken) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWrapSelect, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWrapItemField, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceForm, {
                                title: "From",
                                value: checkBalanceFrom
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemField, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectAssetField, {
                                        onChangeToken: function(newToken) {
                                            return handleSelectToken(newToken);
                                        },
                                        name: "from_token",
                                        lineBottom: true,
                                        label: t("Asset"),
                                        options: tokenSupport.listTokens,
                                        noBorder: true,
                                        selectedToken: selectToken === null || selectToken === void 0 ? void 0 : selectToken.symbol,
                                        isDisabled: false
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectFromField, {
                                        chainId: chainId,
                                        label: t("From"),
                                        name: "from_chains_networks",
                                        options: selectToken === null || selectToken === void 0 ? void 0 : selectToken.fromChains,
                                        selectFromChain: chainId,
                                        noBorder: true,
                                        onChange: function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                                var ref, error;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _state.trys.push([
                                                                0,
                                                                4,
                                                                ,
                                                                5
                                                            ]);
                                                            if (!account) return [
                                                                3,
                                                                2
                                                            ];
                                                            return [
                                                                4,
                                                                switchNetworkAsync(e)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            return [
                                                                3,
                                                                3
                                                            ];
                                                        case 2:
                                                            switchNetworkLocal(e);
                                                            _state.label = 3;
                                                        case 3:
                                                            setSelectFromChain(e);
                                                            setToChain((ref = selectToken === null || selectToken === void 0 ? void 0 : selectToken.toChains.find(function(dt) {
                                                                return (dt === null || dt === void 0 ? void 0 : dt.chainId) !== e;
                                                            })) === null || ref === void 0 ? void 0 : ref.chainId);
                                                            return [
                                                                3,
                                                                5
                                                            ];
                                                        case 4:
                                                            error = _state.sent();
                                                            console.log(error);
                                                            return [
                                                                3,
                                                                5
                                                            ];
                                                        case 5:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(e) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLeft, {
                                balanceForFrom: checkBalanceFrom,
                                fillAmount: fillAmount,
                                onChangeAmount: function(value) {
                                    return setFillAmount(value);
                                },
                                symbol: findTokenFrom === null || findTokenFrom === void 0 ? void 0 : findTokenFrom.symbol,
                                isMinAmount: isMintAmountTransfer,
                                isMaxAmount: isMaxAmountTransfer,
                                minAmount: minAmount,
                                maxAmount: maxAmount,
                                isNotBalanceToTransfer: isNotBalanceToTransfer,
                                childrenPercent: /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentPrice, {
                                    setFillAmount: setFillAmount,
                                    balanceFrom: account ? balanceFrom : null
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsArrowRight, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrapButton, {
                            onClick: handleSwapChain,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWrapItemField, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceForm, {
                                title: "To",
                                value: checkBalanceTo
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemField, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectAssetField, {
                                        onChangeToken: function() {
                                            return null;
                                        },
                                        name: "to_token",
                                        lineBottom: true,
                                        label: t("Asset"),
                                        options: tokenSupport.listTokens,
                                        noBorder: true,
                                        selectedToken: selectToken === null || selectToken === void 0 ? void 0 : selectToken.symbol,
                                        isDisabled: !false
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectToField, {
                                        name: "to_chains_networks",
                                        label: t("To"),
                                        options: selectToken === null || selectToken === void 0 ? void 0 : (ref6 = selectToken.toChains) === null || ref6 === void 0 ? void 0 : ref6.filter(function(dt) {
                                            var ref;
                                            return (dt === null || dt === void 0 ? void 0 : dt.chainId) !== chainId && (dt === null || dt === void 0 ? void 0 : (ref = dt.fromChain) === null || ref === void 0 ? void 0 : ref.includes(chainId));
                                        }),
                                        noBorder: true,
                                        onChange: function(newChainId) {
                                            return setToChain(newChainId);
                                        },
                                        toChainId: toChain
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputRight, {
                                fillAmount: actuallyReceived,
                                symbol: dataFromToken === null || dataFromToken === void 0 ? void 0 : dataFromToken.symbol,
                                balance: checkBalanceTo
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteSupport, {
                toChain: toChain,
                findTokenTo: findTokenTo,
                bonus: bonus,
                amountMinBonus: amountMinBonus
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsInputSwap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLeft, {
                        balanceForFrom: checkBalanceFrom,
                        fillAmount: fillAmount,
                        onChangeAmount: function(value) {
                            return setFillAmount(value);
                        },
                        symbol: findTokenFrom === null || findTokenFrom === void 0 ? void 0 : findTokenFrom.symbol,
                        isMinAmount: isMintAmountTransfer,
                        isMaxAmount: isMaxAmountTransfer,
                        minAmount: minAmount,
                        maxAmount: maxAmount,
                        isNotBalanceToTransfer: isNotBalanceToTransfer,
                        childrenPercent: /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentPrice, {
                            setFillAmount: setFillAmount,
                            balanceFrom: account ? balanceFrom : null
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputRight, {
                        fillAmount: actuallyReceived,
                        symbol: findTokenTo === null || findTokenTo === void 0 ? void 0 : findTokenTo.symbol,
                        balance: checkBalanceTo
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWapButtonSwap, {
                children: [
                    account && /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonSwap, {
                        disabled: loadingTx || isMintAmountTransfer || isMaxAmountTransfer || isNotBalanceToTransfer || (dataTokenTransfer === null || dataTokenTransfer === void 0 ? void 0 : dataTokenTransfer.isActive) === false,
                        endIcon: loadingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "textDisabled"
                        }) : null,
                        onClick: handleAction,
                        children: !checkIsApproved ? t("Approve") : t("Swap")
                    }),
                    !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonSwap, {
                            children: t("Connect Wallet")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Note, {
                feePercent: feePercent,
                feeMin: feeMin,
                addressToSymbol: findTokenFrom === null || findTokenFrom === void 0 ? void 0 : findTokenFrom.symbol
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/HomePage/components/index.ts





;// CONCATENATED MODULE: ./src/views/HomePage/index.tsx





var HomePage = function() {
    var ref = (0,react.useState)(""), feePercent = ref[0], setFeePercent = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageFullWidth/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFormSwap, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSwap, {
                        onHandleChangeFee: function(newFee) {
                            return setFeePercent(newFee);
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/views/index.ts


;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage, {});
};
IndexPage.chains = config/* CHAIN_ID_PAGES */.N6;
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 1365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./137.ts": [
		57513,
		513
	],
	"./1975.ts": [
		55386,
		386
	],
	"./56.ts": [
		91509,
		509
	],
	"./index.ts": [
		63061
	],
	"./type.ts": [
		76839,
		839
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1365;
module.exports = webpackAsyncContext;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [372,171,333,933,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);